export function getImageUrl(imageFetchId){
	return `/hotdeals/rest/image/${imageFetchId}`;
}

export function getParameterByName(name) {
	var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function getLanguageUrlParameter(){
	switch (getParameterByName('l')) {
		case 'nl':
			return 'NL';
		case 'fr':
			return 'FR';
		case 'en':
			return 'EN';
		default:
			return null;
	}
}